<template>
  <div class="container">
    <div class="item" v-for="(item,index) in list" :key="index">
      <div class="productImg">
        <img :src="item.img" alt="5G基站测试方案 5G test multi-UE 多UE自动化测试"/>
      </div>
      <div class="productDescribe">
        <div class="title">{{item.title}}</div>
        <div class="describe">
          <!-- {{item.describe}} -->
          <div v-for="(item,index) in item.describe" :key="index" class="line">{{item.line}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      // list: [
      //   {
      //     img: "static/img/m170.jpg",
      //     title: "5G基站测试方案",
      //     describe: [
      //       { line: "移动通信技术从最早的模拟制式到GSM、3G、LTE、5G一路演进，gNodeB的技术复杂度已经达到了相当的程度。大流量、多天线和大容量的要求使得实验室的测试工作任务非常繁重。基站从开发到正真商用，其中的功能性测试、话务量和性能测试、自动化回归测试、稳定性测试等各个环节比不可少。这些测试包括单个UE的测试，十多个或数十个UE的测试， 以及数百个乃至上千个UE的测试。耐森雷特的MUTA方案提供了全套的软硬件系统，解决了这些测试中对UE的自动化控制的问题，使得基站能够以更高的效率完成开发，以更好的质量提前商用。" },
      //     ]
      //   }
      // ]
      list:this.$store.state.language.j
    };
  },
  watch:{
    '$store.state.language.j'(val){
      console.log(val)
      this.list = val
    }
  }
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  border-top: 1px solid white;
}
.item {
  width: 70%;
  margin: 0 auto;
  margin-top: 30px;
  overflow: auto;
  padding-bottom: 1rem;
}
.productImg {
  width: 20rem;
  height: 20rem;
  float: left;
}
.productImg img {
  width: 100%;
  height: 100%;
}
.productDescribe {
  margin-left: 3rem;
  width: calc(100% - 23rem);
  min-height: 17rem;
  float: left;
}
.title {
  height: 4rem;
  line-height: 4rem;
  text-indent: 2rem;
  font-size: 1.5rem;
}
.describe {
  min-height: 10rem;
  line-height: 2rem;
  text-indent: 2rem;
  font-size: 1.2rem;
}
.line {
  width: 100%;
  min-height: 2rem;
  line-height: 2rem;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/application/5gTest.vue